import i18next from 'i18next'
import { RowType } from '../../../../../redux/context/customReports/typesVariable'
import { ReportDataType } from '../../../../../redux/context/reports/types'
import { BudgetingScenario } from '../../../../../features/scenario/types/BudgetingScenario'
import { Formula } from '../../../../../features/formulas/types/Formula'

export const mapScenarios = (scenarios: BudgetingScenario[]) => {
  if (!scenarios) return []
  return scenarios.map(scenario => ({
    value: scenario.id,
    label: scenario.name
  }))
}

export const generateDataTypeCascaderOptions = (budgets: BudgetingScenario[], forecasts: BudgetingScenario[]) => {
  return [
    {
      value: ReportDataType.actuals,
      label: i18next.t('global:actuals')
    },
    {
      value: ReportDataType.budget,
      label: i18next.t('global:budget'),
      children: [
        {
          value: undefined,
          label: i18next.t('global:default')
        },
        ...mapScenarios(budgets)
      ]
    },
    {
      value: ReportDataType.forecast,
      label: i18next.t('global:forecast'),
      children: mapScenarios(forecasts)
    }
  ]
}

export const getMinimumData = (formulas: Formula[], rowType: RowType.keyFigure | RowType.formula, id: number) => {
  if (rowType === RowType.keyFigure) {
    return {
      rowType,
      keyFigureId: id,
      name: i18next.t(`keyFigureStatement:${id}`, {
        lng: 'fi'
      }),
      nameFi: i18next.t(`keyFigureStatement:${id}`, {
        lng: 'fi'
      }),
      nameEn: i18next.t(`keyFigureStatement:${id}`, {
        lng: 'en'
      }),
      nameSv: i18next.t(`keyFigureStatement:${id}`, {
        lng: 'sv'
      })
    }
  }
  const formula = formulas.find(f => f.id === id)
  return {
    rowType,
    formulaId: id,
    name: formula?.name || '',
    nameFi: formula?.nameFi,
    nameEn: formula?.nameEn,
    nameSv: formula?.nameSv
  }
}
